import { AbstractOperator } from './AbstractOperator';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;
export class GreaterThanBlock extends AbstractOperator {
  constructor() {
    super('logic_greater_than_v2', t.to('よりおおきい', 'operator_gt'));
  }
  getCalculatorCode(): string {
    return '>';
  }

  getCalculatorField(): string {
    return ' > ';
  }
}
